package ext

import common.dto.Vec2d
import org.w3c.dom.Window

val Window.aspectRatio get() = innerWidth.toDouble() / innerHeight

val Window.size get() = Vec2d(innerWidth.toDouble(), innerHeight.toDouble())